export const CHANGE_USER_EMAIL = 'CHANGE_USER_EMAIL'
export const CHANGE_USER_EMAIL_SUCCESS = 'CHANGE_USER_EMAIL_SUCCESS'
export const CHANGE_USER_EMAIL_ERROR = 'CHANGE_USER_EMAIL_ERROR'

export const ChangeUserEmail = (data) => ({
  type: CHANGE_USER_EMAIL,
  payload: data
})
